import React from 'react';
export function AboutSection() {
  return <section className="w-full bg-gray-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-7xl mx-auto flex flex-col lg:grid lg:grid-cols-2 gap-10 lg:gap-16 items-stretch" data-id="element-2">
        {/* Mobile: Despre Mine tag + Name + Title (shown only on mobile, before photo) */}
        <div className="flex flex-col items-start lg:hidden order-1" data-id="element-3">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white text-primary font-bold text-xs tracking-widest uppercase mb-4 shadow-sm" data-id="element-4">
            DESPRE MINE
          </span>
          <h2 className="text-4xl font-serif font-bold text-dark mb-2" data-id="element-5">
            Dr. Cornelia Elena Tianu
          </h2>
          <div className="w-16 h-0.5 bg-primary mt-2 mb-4" data-id="element-6"></div>
          <h3 className="text-xl font-semibold text-medium" data-id="element-7">
            Medic Integrativ · Psihoterapeut · Fondatoare Academia de
            PsihoMedicină
          </h3>
        </div>

        {/* Photo */}
        <div className="relative order-2 lg:order-1 flex justify-center" data-id="element-8">
          <div className="relative w-full max-w-[500px] rounded-2xl overflow-visible h-full" data-id="element-9">
            <div className="w-full h-full rounded-2xl overflow-hidden shadow-2xl relative z-10" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/4PsV87YVEzcMVJ4sRCoYei/39.png" alt="Dr. Cornelia Elena Tianu" className="w-full h-full object-cover object-center" data-id="element-11" />
            </div>

            {/* Lotus top-right */}
            <div className="absolute -top-8 -right-8 opacity-55 pointer-events-none z-20" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/mBNw8JmAfFryfUxuY9GAsf/Cover_FB_Profil_Cornelia.png" alt="" className="w-24 h-24 object-contain" data-id="element-13" />
            </div>
            {/* Lotus bottom-left */}
            <div className="absolute -bottom-8 -left-8 opacity-45 pointer-events-none z-20 rotate-180" data-id="element-14">
              <img src="https://cdn.magicpatterns.com/uploads/mBNw8JmAfFryfUxuY9GAsf/Cover_FB_Profil_Cornelia.png" alt="" className="w-24 h-24 object-contain" data-id="element-15" />
            </div>
            {/* Small lotus mid-left */}
            <div className="absolute top-1/3 -left-6 opacity-30 pointer-events-none z-20 -rotate-45" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/mBNw8JmAfFryfUxuY9GAsf/Cover_FB_Profil_Cornelia.png" alt="" className="w-14 h-14 object-contain" data-id="element-17" />
            </div>
            {/* Small lotus mid-right */}
            <div className="absolute bottom-1/3 -right-6 opacity-30 pointer-events-none z-20 rotate-45" data-id="element-18">
              <img src="https://cdn.magicpatterns.com/uploads/mBNw8JmAfFryfUxuY9GAsf/Cover_FB_Profil_Cornelia.png" alt="" className="w-14 h-14 object-contain" data-id="element-19" />
            </div>
          </div>
        </div>

        {/* Right Content */}
        <div className="flex flex-col items-center lg:items-start order-3 lg:order-2" data-id="element-20">
          {/* Desktop: Despre Mine tag + Name + Title (hidden on mobile) */}
          <div className="hidden lg:block" data-id="element-21">
            <span className="inline-block px-4 py-1.5 rounded-full bg-white text-primary font-bold text-xs tracking-widest uppercase mb-4 shadow-sm" data-id="element-22">
              DESPRE MINE
            </span>
            <h2 className="text-4xl font-serif font-bold text-dark mb-2" data-id="element-23">
              Dr. Cornelia Elena Tianu
            </h2>
            <div className="w-16 h-0.5 bg-primary mt-2 mb-4" data-id="element-24"></div>
            <h3 className="text-xl font-semibold text-medium mb-6" data-id="element-25">
              Medic Integrativ · Psihoterapeut · Fondatoare Academia de
              PsihoMedicină
            </h3>
          </div>

          <p className="text-body leading-relaxed mb-4 text-lg" data-id="element-26">
            Ghidez oameni care funcționează perfect în exterior, dar în interior
            sunt epuizați, să se înțeleagă pe ei înșiși și să aleagă conștient
            ce le face bine. Sunt Medic Integrativ și Psihoterapeut, cu o
            experiență de peste 21 de ani în sănătate integrativă.
          </p>

          <p className="text-body leading-relaxed mb-4" data-id="element-27">
            Ca Medic de Familie am ales să fac specializări în{' '}
            <span className="font-semibold text-primary" data-id="element-28">
              Podologie, Apifitoterapie, Homeopatie, Medicină Tradițională
              Indiană și Chineză, Acupunctură, Aromaterapie, Ozonoterapie
            </span>{' '}
            și altele.
          </p>

          <p className="text-body leading-relaxed mb-4" data-id="element-29">
            Ulterior, am completat parcursul medical cu formări în{' '}
            <span className="font-semibold text-primary" data-id="element-30">
              Psihoterapie Nondirectivă Ericksoniană, Psihoterapie Scurtă
              Strategică, Psihanaliză Relațională, Terapie Bach și Terapie
              Craniosacrală
            </span>{' '}
            , pentru că pacienții nu se simțeau bine cu analizele perfecte, iar
            eu ridicam din umeri când mă întrebau de ce totuși nu sunt bine.
          </p>

          <p className="text-body leading-relaxed mb-4" data-id="element-31">
            De-a lungul acestor ani, am ghidat mii de persoane să-și regăsească
            echilibrul trup-minte-suflet, să prevină sau să trateze boala și
            să-și construiască relații împlinite cu ele însele și cu cei din
            jur.
          </p>

          <p className="text-body leading-relaxed mb-8 font-medium" data-id="element-32">
            De curând am pus bazele platformei online{' '}
            <span className="text-primary font-bold" data-id="element-33">
              Academia de PsihoMedicină
            </span>{' '}
            , un sistem integrativ care combină Medicina Alopată, Terapiile
            Alternative, Terapii Naturiste și Psihoterapia, pentru ca persoanele
            să nu mai supraviețuiască, ci să se bucure de o viață trăită
            conștient.
          </p>

          <a href="https://psihomedicina.ro/despre" className="inline-block rounded-full bg-primary text-white font-semibold px-8 py-4 hover:bg-[#5A1D5F] transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200 text-center" data-id="element-34">
            Descoperă mai multe despre mine
          </a>
        </div>
      </div>
    </section>;
}